import {inject, Injectable} from '@angular/core';
import { ErrorLoggerService } from './error-logger.service';
import {Tools_aiConsoleService} from "@llm/service/tools_ai-console.service";

@Injectable({ providedIn: 'root' })
export class ErrorHandlerService {
  //Injectables
  private _console = inject(Tools_aiConsoleService);
  constructor(private logger: ErrorLoggerService) {}

  handleError(error: any, context: string = ''): { message: string; shouldRetry: boolean } {
    this.logger.logError(error, context);

    const status = error.response?.status || 0;
    let message = 'Erro inesperado. Por favor, tente mais tarde.';
    let shouldRetry = false;

    if (error.name === 'AbortError') {
      message = 'Tempo de resposta excedido. Por favor, tente novamente.';
    } else if (status >= 500) {
      message = 'Erro temporário do servidor. Nossa equipe já foi notificada.';
      shouldRetry = true;
    } else if (status === 429) {
      message = 'Muitas solicitações. Por favor, aguarde um momento.';
    }

    return { message, shouldRetry };
  }
}
